var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharged({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7568 16.3275L16.4251 20.6386L16.4251 6.88972C16.4251 6.29909 16.9092 5.81909 17.505 5.81909C18.1008 5.81909 18.5849 6.29909 18.5849 6.88972L18.5849 20.6386L22.2532 16.3275C22.6059 15.9135 23.2305 15.86 23.6481 16.2097C24.0657 16.5595 24.1197 17.1786 23.7669 17.5926L18.261 24.0628C18.072 24.2841 17.7966 24.4108 17.505 24.4108C17.2134 24.4108 16.9362 24.2841 16.749 24.0628L11.2431 17.5926C10.8903 17.1786 10.9443 16.5595 11.3619 16.2097C11.7795 15.86 12.4041 15.9135 12.7568 16.3275Z",
    fill: "#00E261"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.233346 7.31814L5.73927 0.847955C5.92826 0.626691 6.20365 0.5 6.49523 0.5C6.78682 0.5 7.064 0.626691 7.2512 0.847955L12.7571 7.31814C13.1099 7.73212 13.0559 8.3513 12.6383 8.70104C12.2207 9.05078 11.5962 8.99725 11.2434 8.58327L7.57518 4.27219V7.47591C7.57518 8.06654 7.091 8.54654 6.49523 8.54654C5.89946 8.54654 5.41529 8.06654 5.41529 7.47591V4.27219L1.74707 8.58327C1.55088 8.81346 1.27189 8.93123 0.989308 8.93123C0.764319 8.93123 0.537531 8.8545 0.35214 8.69926C-0.0654383 8.34952 -0.119436 7.73033 0.233346 7.31636V7.31814Z",
    fill: "#E1E7EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49427 18.7194C7.09004 18.7194 7.57422 19.1994 7.57422 19.79V23.4294C7.57422 24.02 7.09004 24.5 6.49427 24.5C5.8985 24.5 5.41433 24.02 5.41433 23.4294V19.79C5.41433 19.1994 5.8985 18.7194 6.49427 18.7194Z",
    fill: "#E1E7EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49427 10.2078C7.09004 10.2078 7.57422 10.6878 7.57422 11.2784V15.9856C7.57422 16.5762 7.09004 17.0562 6.49427 17.0562C5.8985 17.0562 5.41433 16.5762 5.41433 15.9856V11.2784C5.41433 10.6878 5.8985 10.2078 6.49427 10.2078Z",
    fill: "#E1E7EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.504 4.05454C16.9083 4.05454 16.4241 3.57454 16.4241 2.98391V1.63313C16.4241 1.0425 16.9083 0.5625 17.504 0.5625C18.0998 0.5625 18.584 1.0425 18.584 1.63313V2.98391C18.584 3.57454 18.0998 4.05454 17.504 4.05454Z",
    fill: "#00E261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharged);
export default __webpack_public_path__ + "static/media/charged.24f04179.svg";
export { ForwardRef as ReactComponent };